import nodes from './nodes';
import stats from './stats';
import members from './members';
import auth from './auth';
import reports from './reports';
import access from './access';

export default {
  nodes,
  stats,
  members,
  auth,
  reports,
  access,
};
